export default __webpack_public_path__ + "graphics/cross.a2a52a47.svg";